import { v4 as uuidv4 } from 'uuid';
export function generateMongoLikeId() {
  return uuidv4().replace(/-/g, '').substring(0, 24);
}
